import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, AlertIcon, Spinner, useMediaQuery } from "@chakra-ui/react";
import BGLogin from "./assets/images/image_login.png";
import LogoImg from "./assets/images/Logo-PNG.png";
import OpenEyeImg from "./assets/images/open_eye.png";
import CloseEyeImg from "./assets/images/close_eye.png";
import PasswordIconImg from "./assets/images/mdi_password-outline.png";
import LogoFooterImg from "./assets/images/logo_footer.png";

const passwordIsValid = (value) =>
  value.length >= 8 && /[A-Z]/.test(value) && new RegExp("[`!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>/?~]").test(value);

export default function ActivateAccount() {
  const token = new URLSearchParams(window.location.search).get("token");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [message, setMessage] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checkingLink, setCheckingLink] = useState(true);
  const [linkBlocked, setLinkBlocked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showImagePanel] = useMediaQuery("(min-width: 769px)");

  useEffect(() => {
    async function validateLink() {
      if (!token) {
        setMessage("El link de validación es inválido.");
        setLinkBlocked(true);
        setCheckingLink(false);
        return;
      }
      try {
        const response = await fetch("user/activateAccount", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token, password: null }),
        });
        const result = await response.json();
        if (result.isError || result.error) {
          setMessage(result.message);
          setLinkBlocked(true);
        }
      } catch {
        setMessage("No se pudo validar el link. Intente nuevamente.");
        setLinkBlocked(true);
      } finally {
        setCheckingLink(false);
      }
    }
    validateLink();
  }, [token]);

  async function activate() {
    setMessage(null);
    if (!token) return setMessage("El link de validación es inválido.");
    if (!passwordIsValid(password))
      return setMessage("La contraseña debe tener al menos 8 caracteres, una mayúscula y un carácter especial.");
    if (password !== confirmation) return setMessage("Las contraseñas no coinciden.");

    setLoading(true);
    try {
      const response = await fetch("user/activateAccount", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const result = await response.json();
      const apiResult = result.data || result;
      const isError = apiResult.isError === true || result.error === true;
      setMessage(apiResult.message || result.message);
      setSuccess(!isError);
    } catch {
      setMessage("No se pudo validar la cuenta. Intente nuevamente.");
    } finally {
      setLoading(false);
    }
  }

  const inputStyle = { border: "none", outline: "none", flex: 1, fontSize: 15, color: "#333", background: "transparent", textAlign: "center" };
  const inputWrapperStyle = { display: "flex", alignItems: "center", border: "1px solid rgba(98, 134, 172, 0.5)", borderRadius: 8, padding: "12px 16px", background: "#fff" };
  const iconStyle = { width: 20, height: 20, marginRight: 12, flexShrink: 0 };
  const eyeStyle = { width: 20, height: 20, cursor: "pointer", flexShrink: 0 };
  const inputContainerStyle = { width: "100%", marginBottom: 16, position: "relative" };

  return (
    <div style={{ display: "flex", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      <style>{`.login-input { text-align: center; }.login-input::placeholder { text-align: center; }`}</style>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "40px 60px", background: "#fff" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: 500, margin: "0 auto", width: "100%", paddingTop: 100 }}>
          <div style={{ textAlign: "center", marginBottom: 45 }}>
            <img src={LogoImg} alt="Hospital Británico" style={{ maxHeight: 80, width: "auto" }} />
          </div>

          <h1 style={{ fontWeight: 600, fontSize: 24, lineHeight: "24px", letterSpacing: "0%", textAlign: "center", color: "#004890", marginBottom: 45 }}>Ingrese nueva contraseña</h1>

          {checkingLink ? (
            <Spinner color="#004890" />
          ) : success ? (
            <>
              <div style={{ width: "100%", marginBottom: 30 }}>
                <Alert status="success" borderRadius="5px"><AlertIcon />{message}</Alert>
              </div>
              <Link to="/" style={{ color: "#004890", fontSize: 14 }}>
                Ir a iniciar sesión
              </Link>
            </>
          ) : (
            <>
{!linkBlocked && (
                <div style={inputContainerStyle}>
                  <div style={inputWrapperStyle}>
                    <img src={PasswordIconImg} alt="" style={iconStyle} />
                    <input
                      className="login-input"
                      type={showPassword ? "text" : "password"}
                      placeholder="Contraseña"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={inputStyle}
                    />
                    {showPassword ? (
                      <img src={OpenEyeImg} alt="Ocultar contraseña" style={eyeStyle} onClick={() => setShowPassword(false)} />
                    ) : (
                      <img src={CloseEyeImg} alt="Mostrar contraseña" style={eyeStyle} onClick={() => setShowPassword(true)} />
                    )}
                  </div>
                </div>
              )}

              {!linkBlocked && (
                <div style={{ ...inputContainerStyle, marginBottom: 20 }}>
                  <div style={inputWrapperStyle}>
                    <img src={PasswordIconImg} alt="" style={iconStyle} />
                    <input
                      className="login-input"
                      type={showConfirmation ? "text" : "password"}
                      placeholder="Repita Contraseña"
                      value={confirmation}
                      onChange={(e) => setConfirmation(e.target.value)}
                      style={inputStyle}
                    />
                    {showConfirmation ? (
                      <img src={OpenEyeImg} alt="Ocultar contraseña" style={eyeStyle} onClick={() => setShowConfirmation(false)} />
                    ) : (
                      <img src={CloseEyeImg} alt="Mostrar contraseña" style={eyeStyle} onClick={() => setShowConfirmation(true)} />
                    )}
                  </div>
                </div>
              )}

              {message && <div style={{ width: "100%", marginBottom: 16 }}><Alert status="warning" borderRadius="5px"><AlertIcon />{message}</Alert></div>}

              {!linkBlocked && (
                <button
                  type="button"
                  onClick={activate}
                  disabled={loading}
                  style={{
                    width: "100%",
                    padding: "14px",
                    background: "#004890",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    fontSize: 16,
                    fontWeight: 600,
                    cursor: loading ? "not-allowed" : "pointer",
                    marginBottom: 30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                  }}
                >
                  {loading ? <Spinner size="sm" color="white" /> : "Activar cuenta"}
                </button>
              )}

              <Link to="/" style={{ color: "#004890", fontSize: 14 }}>
                Volver al inicio de sesión
              </Link>
            </>
          )}
        </div>

        <div style={{ textAlign: "center", padding: "20px 0", fontSize: 13, color: "#999", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
          <img src={LogoFooterImg} alt="Hospital Británico" style={{ height: 14, width: 35 }} />
          <span>Hospital Británico | © 2025</span>
        </div>
      </div>

      {showImagePanel && (
        <div style={{ flex: 1, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <img
            src={BGLogin}
            alt="Portal de prestadores"
            style={{ width: "100%", height: "100%", position: "fixed" }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 150,
              left: 0,
              right: 0,
              background: "linear-gradient(180deg, #020A14,#395D84 )",
              padding: "40px 50px",
              color: "#fff",
              textAlign: "center",
              opacity: 0.6,
            }}
          >
            <h2 style={{ fontWeight: 400, fontSize: "39.84px", lineHeight: "48px", letterSpacing: 0, textAlign: "center", color: "#FFFFFF", marginBottom: 10 }}>
              Bienvenido al portal de prestadores
            </h2>
            <p style={{ fontWeight: 400, fontSize: "19.84px", lineHeight: "24px", letterSpacing: "0%", textAlign: "center", verticalAlign: "middle", opacity: 0.9 }}>
              Gestioná tus servicios de forma agil, simple y segura
            </p>
          </div>
        </div>
        )}
    </div>
  );
}
